import { MemberSubscriptionStatus } from '@vista-digital/ocapi-types/v1';
import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { assertIsError } from '../../../../../utils/assert-is-error';
import { logger } from '../../../../../utils/logger';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { getMemberSubscriptions } from '../../../selectors/member/subscriptions/get-member-subscriptions';
import { clearCurrentMemberSubscriptionBillingError } from './clear-current-member-subscription-billing-error';
export const reactivateCurrentMemberSubscription = async () => {
    if (!isMemberSignedIn())
        throw new Error('Cannot reactivate subscription when no user is signed in.');
    const memberSubscriptions = getMemberSubscriptions();
    if (!memberSubscriptions) {
        throw new Error('Cannot reactivate subscription when member details have not been loaded or member has no subscriptions.');
    }
    if (memberSubscriptions.current.status !== MemberSubscriptionStatus.Frozen) {
        throw new Error('Cannot reactivate subscription when the current subscription is not frozen.');
    }
    try {
        await ocapiClient.instance.v1.loyalty.members.subscriptions.reactivateCurrent();
        runInAction(() => {
            memberSubscriptions.current.status = MemberSubscriptionStatus.Active;
            clearCurrentMemberSubscriptionBillingError();
        });
    }
    catch (error) {
        assertIsError(error);
        logger.error(error.message);
        throw error;
    }
};
